export default __webpack_public_path__ + "static/media/valueMatch.d79142c8.png";